import script from "./ShareButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareButtons.vue?vue&type=script&setup=true&lang=js"

import "./ShareButtons.vue?vue&type=style&index=0&id=267251b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-267251b8"]])

export default __exports__